'use client';

import type { UrlObject } from 'node:url';
import { usePathname } from 'next/navigation';

// 指定されたhrefが現在のパスと異なるかどうかを判定するカスタムフック
function useIsMovingToOtherPath() {
  const pathname = usePathname();

  const getMoveToPathname = (href: string | UrlObject) => {
    if (typeof href === 'string') {
      return new URL(href, process.env.NEXT_PUBLIC_BASE_URL).pathname;
    }
    return href.pathname || '/';
  };

  const isMovingToOtherPath = (href: string | UrlObject) => {
    const moveToPathname = getMoveToPathname(href);
    return moveToPathname !== pathname;
  };

  return isMovingToOtherPath;
}

export default useIsMovingToOtherPath;
